import { FetchOptions } from '../components/interfaces';

export default class DataService {

  protected handler = async<T>(action: () => Promise<T>) => {
    return (await this.pureHandler(action)).data;
  }

  protected pureHandler = async<T>(action: () => Promise<T>) => {
    try {
      return ((await action()) as any);
    }
    catch (e) {
      if (e && e.response) {
        console.error(e.response);
      }
      else {
        console.error(e);
      }
      throw e;
    };
  }

  protected provideFetchOptions = (options: FetchOptions, defaults?: Partial<FetchOptions>) => {
    if (options == null) options = {};
    if (typeof defaults !== 'object') defaults = {};
    options.q = options.q ?? defaults.q ?? '';
    options.count = options.count ?? defaults.page ?? 10;
    options.page = options.page ?? defaults.page ?? 1;
    options.sort = options.sort ?? defaults.sort ?? 'createdAt';
    options.sortOrder = options.sortOrder ?? defaults.sortOrder ?? 'desc';
    return options;
  }

}
